import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class DateRangeSelectorProvider {
  public selection$: BehaviorSubject<{ start: Date; end: Date }>;

  public timeScale$ = new BehaviorSubject<string>('month');

  constructor() {
    const today = dayjs();

    const day = today.date();

    // If less than 1 week has passed since start of month, also include last month
    //
    if (day < 7) {
      today.subtract(1, 'months');
    }

    this.selection$ = new BehaviorSubject({
      start: today.startOf('month').toDate(),
      end: new Date(),
    });
  }
}
